import React, { useState } from "react";
import {
  Navbar,
  Nav,
  NavDropdown,
  Container,
  Button,
  Modal,
  Form,
  Image,
  Row,
  Col,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS
// import Lelo from "./logo-lelotrip.png";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"; 
// import "./MainNav.css";
// import "./LoginModal.css";
import "./Booking.css";
import { Swiper, SwiperSlide } from "swiper/react";
import emailjs from "emailjs-com";
import "swiper/css";
import "swiper/css/navigation";

import { Autoplay, Navigation } from "swiper/modules";
import { toast } from "react-toastify";
const BookingFormModal = ({ active, setShow, setActive, handleShow }) => {
 const [formData, setFormData] = useState({
   name: "",
   mobile: "",
   email: "",
   date: "",
   procedure: "", 
   requirements: "",
 });
 const [loading, setLoading] = useState(false);
 const [responseMessage, setResponseMessage] = useState("");

 const handleChange = (e) => {
   const { name, value } = e.target;
   setFormData({ ...formData, [name]: value });
 };
 const handleDateChange = (date) => {
   setFormData({ ...formData, date });
 };
 const handleSubmit = (e) => {
   e.preventDefault();
   setLoading(true); // Set loading to true when submitting the form

   const serviceId = "service_y2wiyv9";
   const templateId = "template_vdgakx6";
   const userId = "gHJShnDhyA9tSUzLk";

   emailjs
     .send(serviceId, templateId, formData, userId)
     .then(
       (result) => {
         setResponseMessage("Your booking request has been submitted!");
         setFormData({
           name: "",
           mobile: "",
           email: "",
           date: "",
           procedure: "", // Clear procedure after submission
           requirements: "",
         });
         toast.success("Your booking request has been submitted!");
         setActive(false);
       },
       (error) => {
         setResponseMessage("Failed to submit the request. Please try again.");
         toast.error("Failed to submit the request. Please try again.");
       }
     )
     .finally(() => {
       setLoading(false); // Set loading to false after submission (success or failure)
     });
 };
  return (
    <Modal
      show={active}
      onHide={setActive}
      className="p-fixed l-0 r-0 b-0 t-0 flex flex-center flex-middle z-70 signup_modal"
      style={{ backgroundColor: "#000000a1", zIndex: 10000 }}
      size="lg"
    >
      <Modal.Body>
        <div
          className="p-fixed l-0 r-0 b-0 t-0 flex flex-center flex-middle z-70"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.4)", zIndex: "10000" }}
        >
          <div className="p-relative">
            <div>
              <div className="d-flex" style={{ justifyContent: "center" }}>
                <div
                  className="o-hidden flex-column brLogin-4 slick-dots slider_part"
                  style={{ width: "555px", height: "555px" }}
                >
                  <Swiper
                    autoplay={{
                      delay: 2500,
                      disableOnInteraction: false,
                    }}
                    navigation={true}
                    modules={[Navigation, Autoplay]}
                    className="mySwiper"
                  >
                    <SwiperSlide>
                      {/* <img
                        src="https://promos.makemytrip.com/notification/xhdpi/Roadblock-DilMaange-386x540-5Aug.jpg"
                        alt=""
                        style={{ height: "600px", objectFit: "cover" }}
                      /> */}

                      <img
                        src="https://img.freepik.com/premium-photo/beautiful-woman-gets-injections_396282-9.jpg?w=900"
                        alt="studio final take music offer"
                        style={{ height: "555px" }}
                        className="image_sign_up_modal"
                      />
                    </SwiperSlide>
                  </Swiper>
                </div>
                <div
                  className="bg-white o-hidden d-flex flex-column brLoginNew-4 signup_form"
                  style={{ width: "555px", height: "555px" }}
                >
                  <div className=" d-flex flex-1 flex-column">
                    <div className="pt-6 pb-6 flex flex-top flex-between">
                      <div
                        className="px-1 flex flex-middle nmx-1 pb-1 "
                        style={{ borderRadius: "14px", textAlign: "end" }}
                        onClick={() => setActive(false)}
                      >
                        <svg
                          width="30"
                          height="30"
                          viewBox="0 0 24 24"
                          fill="none"
                          className="c-pointer c-neutral-900"
                        >
                          <path
                            d="M18 6L12 12M12 12L6 18M12 12L6 6M12 12L18 18"
                            stroke="#1A1A1A"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <div className="d-flex px-8 flex-1 flex-between flex-column">
                      <div>
                        <Row>
                          <Form onSubmit={handleSubmit}>
                            <div style={{ display: "flex", gap: "20px" }}>
                              <div className="mb-3">
                                <label htmlFor="name" className="form-label">
                                  Name
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="name"
                                  name="name"
                                  value={formData.name}
                                  onChange={handleChange}
                                  required
                                />
                              </div>

                              <div className="mb-3">
                                <label htmlFor="mobile" className="form-label">
                                  Mobile Number
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="mobile"
                                  name="mobile"
                                  value={formData.mobile}
                                  onChange={handleChange}
                                  required
                                />
                              </div>
                            </div>

                            {/* <div className="mb-3">
                              <label htmlFor="email" className="form-label">
                                Email Id
                              </label>
                              <input
                                type="email"
                                className="form-control"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                              />
                            </div> */}

                            {/* <div className="date-time-booking-form"> */}
                            <div className="mb-3 date-time-booking-form-firstdiv">
                              <label htmlFor="dateTime" className="form-label">
                                Date
                              </label>
                              <DatePicker
                                selected={formData.date}
                                onChange={handleDateChange}
                                dateFormat="yyyy-MM-dd"
                                placeholderText="Select date"
                                className="form-control"
                                required
                              />
                            </div>
                            <div className="mb-3" style={{ width: "100%" }}>
                              <label htmlFor="procedure" className="form-label">
                                Choose Category
                              </label>
                              <select
                                name="procedure"
                                value={formData.procedure}
                                onChange={handleChange}
                                required
                              >
                                <option value="">Select Category</option>
                                <option value="Rhinoplasty">Rhinoplasty</option>
                                <option value="Septoplasty">Septoplasty</option>
                                <option value="Lipoma">Lipoma</option>
                                <option value="Gynecomastia">
                                  Gynecomastia
                                </option>
                                <option value="Ophthalmology">
                                  Ophthalmology
                                </option>
                                <option value="Lasik surgery">
                                  Lasik surgery
                                </option>
                                <option value="Cataract surgery">
                                  Cataract surgery
                                </option>
                                <option value="ICL (implantable collamer lens) treatment">
                                  ICL (implantable collamer lens) treatment
                                </option>
                                <option value="Glaucoma treatment">
                                  Glaucoma treatment
                                </option>
                                <option value="Corneal surgery">
                                  Corneal surgery
                                </option>
                                <option value="Pediatrics Eye care">
                                  Pediatrics Eye care
                                </option>
                                <option value="RLE (Refractive Lens Exchange)">
                                  RLE (Refractive Lens Exchange)
                                </option>
                                <option value="Hair transplant">
                                  Hair transplant
                                </option>
                                <option value="Skin">Skin</option>
                                <option value="Face">Face</option>
                                <option value="Body">Body</option>
                                <option value="Breast (implant)">
                                  Breast (implant)
                                </option>
                                <option value="Gynaecology">Gynaecology</option>
                                <option value="Liposuction">Liposuction</option>
                              </select>
                            </div>
                            {/* </div> */}

                            <div className="mb-3 text-area-reqiremenet">
                              <label
                                htmlFor="requirements"
                                className="form-label"
                              >
                                Write your Message here...
                              </label>
                              <textarea
                                className="form-control"
                                id="requirements"
                                name="requirements"
                                value={formData.requirements}
                                onChange={handleChange}
                                rows={3}
                                required
                              />
                            </div>

                            <div className="text-right">
                              <Button
                                type="submit"
                                className="booking-Request-btn btn btn-primary mr-2"
                                style={{ width: "100%" }}
                                disabled={loading}
                              >
                                {loading ? "Submitting..." : "Submit Booking"}
                              </Button>
                            </div>

                            {/* {responseMessage && (
        <div className="response-message">
          <p>{responseMessage}</p>
        </div>
      )} */}
                          </Form>
                        </Row>
                        {/* <div
                          className="m-0 mt-0 mb-0 ml-0 mr-0 mx-0 my-0 mt-6 margin-modalbooking"
                          style={{ height: "1px", width: "1px" }}
                        ></div>
                        <Button className="h-10 bg-black-500 hover:bg-black-500 bg-secondary-500 hover:bg-secondary-600 c-white bc-transparent c-pointer w-100p py-2 px-4 h-9 fs-4 fw-600 t-all button bs-solid tp-color td-500 bw-1 br-4 lh-solid box-border">
                          <span className="fs-3 fw-500">Get OTP</span>
                        </Button> */}
                        {/* <div
                          className="mt-5 fs-12 fw-400 c-neutral-grey ta-center"
                          style={{ marginTop: "20px" }}
                        >
                          Sell and distribute your music on all major platforms
                          worldwide.
                        </div> */}
                      </div>
                      {/* <div className="mb-3">
                            <div className="pos-r">
                            <div className="bc-grey-10 d-block bb bc-grey-10 flex-1"></div>
                            </div>
                            <div className="mt-3 d-flex flex-column flex-middle">
                            <span>
                                <span className="fs-2 c-grey-70">
                                By continuing, you agree to Studio Final Take
                                </span>
                                <span className="fs-2 fw-500 c-blue c-pointer">
                                {" "}
                                privacy policy
                                <span className="fs-2 fw-500 c-blue c-pointer">
                                    & terms of use.
                                </span>
                                </span>
                            </span>
                            <span></span>
                            </div>
                        </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      {/* </div> */}
    </Modal>
  );
};

export default BookingFormModal;
